import { Icon } from "@iconify/react";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  size?: number;
}

/**
 * Battle.net brand mark via Iconify (`simple-icons:battlenet`).
 * Inherits `currentColor` from the parent so it works on both the
 * white-on-blue Battle.net button and as a small chip in the Topbar.
 */
export function BattleNetIcon({ className, size = 18 }: Props) {
  return (
    <Icon
      icon="simple-icons:battledotnet"
      width={size}
      height={size}
      className={cn("inline-block shrink-0", className)}
      aria-hidden="true"
    />
  );
}
